import { ActionType } from "../../../constants/ActionTypes";

export default function currenciesReducer(state = {}, action = {}) {
	switch (action.type) {
		case ActionType.GET_PROJECT_CURRENCIES_SUCCESS:
			return {
				...state,
				inLoadingProcess: false,
				data: action.payload,
			};
		case ActionType.GET_ALL_CURRENCIES_ERROR:
			return {
				...state,
				inLoadingProcess: false,
			};
		case ActionType.GET_CURRENCIES_BEGIN:
			return {
				...state,
				inLoadingProcess: true,
				inSavingProcess: false,
				data: [],
			};
		case ActionType.SET_CURRENCIES_BEGIN:
			return {
				...state,
				inSavingProcess: true,
			};
		case ActionType.SET_PROJECTS_CURRENCIES_ERROR:
			return {
				...state,
				error: action.payload,
				inSavingProcess: false,
			};
		case ActionType.SET_PROJECTS_CURRENCIES_SUCCESS:
			return {
				...state,
				inSavingProcess: false,
				data: action.payload,
			};
		default:
			return state;
	}
}
